import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Warnings } from '../models/iCourrier/httpErrors/warnings.enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private errors = new Subject<Warnings[]>();

  public addErrors = (errors: Warnings[]): void => this.errors.next(errors);

  public getErrors = (): Observable<Warnings[]> => this.errors.asObservable();
}
